import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import SectionTitle from "@/components/base/SectionTitle";
import NewsCard from "@/components/base/NewsCard";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import HotTags from "./components/HotTags";
import TopicPicks from "./components/TopicPicks";
import ChannelStrip from "./components/ChannelStrip";
import {
  getFeatured,
  getLatest,
  getHottest,
  getPopularTags,
  formatViews,
} from "@/utils/news";

export default function Home() {
  const featured = getFeatured();
  const latest = getLatest(8);
  const hottest = getHottest(8);
  const tags = getPopularTags(12);

  return (
    <Layout>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 md:py-8">
        {/* Hero */}
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5 animate-fade-up">
          <div className="lg:col-span-2">
            <HeroCarousel items={featured} />
          </div>
          <div className="flex flex-col gap-4 md:gap-5">
            <CategoryShortcuts />
            <HotTags tags={tags} />
          </div>
        </section>

        {/* Channel strip */}
        <section className="mt-5 md:mt-6">
          <ChannelStrip />
        </section>

        {/* Latest + Hot */}
        <section className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <SectionTitle
              title="最新资讯"
              subtitle="按发布时间实时更新，抢先一步掌握娱乐圈动态"
              moreTo="/category/entertainment-news"
              icon="ri-flashlight-line"
            />
            <div className="flex flex-col gap-3 md:gap-4">
              {latest.map((article) => (
                <NewsCard key={article.id} article={article} variant="horizontal" />
              ))}
            </div>
          </div>

          <aside>
            <SectionTitle title="热门榜单" subtitle="综合点击与分享热度" icon="ri-fire-line" />
            <div className="rounded-lg bg-background-50 border border-background-200 p-4">
              {hottest.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/detail/${article.id}`}
                  className="flex items-start gap-3 py-3 border-b border-background-100 last:border-0 cursor-pointer group"
                >
                  <span
                    className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </p>
                    <p className="mt-1 text-xs text-foreground-400 flex items-center gap-2">
                      <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                        {article.category}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-400" />
                        {formatViews(article.views)}
                      </span>
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </aside>
        </section>

        {/* Editor picks / topics */}
        <section className="mt-8 md:mt-12">
          <SectionTitle
            title="编辑精选专题"
            subtitle="编辑部特别策划，带你深入了解重点话题"
            icon="ri-award-line"
          />
          <TopicPicks />
        </section>

        {/* Channel highlight cards */}
        <section className="mt-8 md:mt-12">
          <SectionTitle title="频道推荐" subtitle="按兴趣进入专属频道，聚合你关心的内容" icon="ri-live-line" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {hottest.slice(0, 3).map((article) => (
              <NewsCard key={article.id} article={article} variant="grid" />
            ))}
          </div>
        </section>
      </div>
    </Layout>
  );
}